<script setup lang="ts"></script>
<template>
  <div
    id="modalCarSize"
    class="modal fade"
    aria-labelledby="modalCarSizeLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title">
            車体サイズの基準の一つとなる、ナンバーや軽自動<br />車の規格において、以下のサイズとなります。
          </div>
        </div>
        <div class="first-modal-body">
          <table class="title-table">
            <tbody>
              <tr>
                <th class="vertical-border light-back" />
                <th class="vertical-border light-back title">軽自動車</th>
                <th class="vertical-border light-back title">5ナンバー</th>
                <th class="vertical-border light-back title">3ナンバー</th>
              </tr>
              <tr>
                <td class="vertical-border dark-back length-name">全長</td>
                <td class="vertical-border dark-back mm-content">
                  3,400mm以下
                </td>
                <td class="vertical-border dark-back mm-content">
                  4,700mm以下
                </td>
                <td class="vertical-border dark-back mm-content">
                  4,701mm以上
                </td>
              </tr>
              <tr>
                <td class="vertical-border light-back length-name">全幅</td>
                <td class="vertical-border light-back mm-content">
                  1,480mm以下
                </td>
                <td class="vertical-border light-back mm-content">
                  1,700mm以下
                </td>
                <td class="vertical-border light-back mm-content">
                  1,701mm以上
                </td>
              </tr>
              <tr>
                <td class="vertical-border dark-back length-name">全高</td>
                <td class="vertical-border dark-back mm-content">
                  2,000mm以下
                </td>
                <td class="vertical-border dark-back mm-content">
                  2,000mm以下
                </td>
                <td class="vertical-border dark-back mm-content">
                  2,001mm以上
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-header">
          <div class="modal-title">
            また、駐車場の<span class="font-bold">上限サイズ目安</span
            >は以下のようになり<br />ます。
          </div>
        </div>
        <div class="second-modal-body">
          <table class="title-table">
            <tbody>
              <tr>
                <th class="vertical-border light-back" />
                <th class="vertical-border light-back title">平面駐車場</th>
                <th class="vertical-border light-back title">機械式駐車場</th>
              </tr>
              <tr>
                <td class="vertical-border dark-back length-name">全長</td>
                <td class="vertical-border dark-back mm-content">
                  4,900〜5,800mm以下
                </td>
                <td class="vertical-border dark-back mm-content">
                  4,700〜5,600mm以下
                </td>
              </tr>
              <tr>
                <td class="vertical-border light-back length-name">全幅</td>
                <td class="vertical-border light-back mm-content">
                  1,900〜2,000mm以下
                </td>
                <td class="vertical-border light-back mm-content">
                  1,700〜2,050mm以下
                </td>
              </tr>
              <tr>
                <td class="vertical-border dark-back length-name">全高</td>
                <td class="vertical-border dark-back mm-content">
                  2,000〜2,300mm以下
                </td>
                <td class="vertical-border dark-back mm-content">
                  2,000〜2,100mm以下
                </td>
              </tr>
              <tr>
                <td class="vertical-border light-back length-name">重量</td>
                <td class="vertical-border light-back mm-content">
                  2,000〜2,500kg以下
                </td>
                <td class="vertical-border light-back mm-content">
                  1,600〜2,300kg以下
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="attention">
          <div class="attention-title">
            ※あくまで目安のため、クルマを検討される際には<br />ご利用される駐車場サイズを必ず確認ください。
          </div>
        </div>
        <div class="container" style="margin: 0">
          <div class="row">
            <div class="close-area">
              <button
                ref="closeModalRef"
                type="button"
                class="btn close text-close"
                data-bs-dismiss="modal"
              >
                閉じる
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.modal .modal-content {
  border-radius: 12px;
}

.modal .modal-dialog {
  left: 50%;
  padding: 7px;
  left: 0;
}

.modal-content .modal-header {
  background-color: #ffffff;
  border-radius: 12px 12px 0px 0px;
  border-bottom: none;
  margin-top: 10px;
  padding: 10px 10px;
  display: flex;
  justify-content: center;
}

.attention {
  background-color: #ffffff;
  border-radius: 12px 12px 0px 0px;
  border-bottom: none;
  margin: 0px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 15px;
  display: flex;
  justify-content: center;
}

.attention-title {
  min-width: 320px;
  font-size: 13px;
}

.modal-content .modal-title {
  min-width: 320px;
  font-size: 13px;
}

.font-bold {
  font-weight: bold;
  font-size: 14px;
}

.first-modal-body {
  width: 100%;
  word-wrap: break-word;
  font-size: 12px;
  padding: 0px 8px 5px 8px;
  display: flex;
  justify-content: center;
}

.second-modal-body {
  width: 100%;
  word-wrap: break-word;
  font-size: 12px;
  padding: 0px 8px 10px 8px;
  display: flex;
  justify-content: center;
}

.close-area {
  background-color: #ececec;
  border-radius: 0px 0px 12px 12px;
  height: 35px;
}
.text-close {
  width: 100%;
  text-align: center;
  font-size: 12px;
}

.title-table {
  border: 1px solid #e5e5e5;
}

.vertical-border {
  border-right: 1px solid #e5e5e5;
}

.dark-back {
  background-color: #eeeeee;
}

.light-back {
  background-color: #f7f8fa;
}

.title {
  font-weight: bold;
  height: 50px;
  padding: 0 5px;
}

.length-name {
  font-weight: bold;
  text-align: center;
  width: 45px;
  height: 50px;
  font-size: 12px;
}
.mm-content {
  padding: 0px 5px;
  font-size: 12px;
}
</style>
